/** Banks shown in the Connect picker and the linked-account sidebar on every host. */
export const ENABLED_BANKS = new Set([
  'hsbc',
  'lloyds',
  'lloyds_business',
  'natwest',
  'aib',
  'nationwide',
  'danske',
  'revolut',
  'starling',
]);

export function isEnabledBank(bankName: unknown) {
  return ENABLED_BANKS.has(String(bankName || '').toLowerCase());
}
